import React, { useState } from 'react';
import styled from 'styled-components';

import {
	OutlinedInput,
	InputAdornment,
	IconButton,
	InputLabel,
	FormControl,
} from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const Root = styled.div`
	.MuiFormControl-root {
		width: 100%;
	}
`;

const InputPassword = ({
	dispatch,
	passwordValue,
	hideVisibleIcon = false,
	customInputlabel = 'Passwort *',
}) => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<Root>
			<FormControl variant="outlined">
				<InputLabel>{customInputlabel}</InputLabel>
				<OutlinedInput
					value={passwordValue}
					variant="outlined"
					required
					fullWidth
					type={showPassword ? 'text' : 'password'}
					autoComplete="false"
					onChange={dispatch}
					endAdornment={
						<InputAdornment
							position="end"
							style={{ display: hideVisibleIcon ? 'none' : '' }}
						>
							<IconButton
								onClick={() => setShowPassword(!showPassword)}
								onMouseDown={(e) => e.preventDefault()}
							>
								{showPassword ? <Visibility /> : <VisibilityOff />}
							</IconButton>
						</InputAdornment>
					}
				/>
			</FormControl>
		</Root>
	);
};

export default InputPassword;
